// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ocXQoK-y7DgIx6zr6KlYzw\\=\\={align-items:center;border:2px dashed var(--gray50);display:flex;height:17rem;justify-content:center;margin:3rem 0 0}", "",{"version":3,"sources":["/app/client_react/src/components/Dropzone/LazyDropzone.styl"],"names":[],"mappings":"AAAA,4BACE,kBAAa,CACb,+BAAQ,CACR,YAAS,CACT,YAAQ,CACR,sBAAiB,CACjB,eAAQ","file":"LazyDropzone.styl","sourcesContent":[":local(.global) {\n  align-items: center;\n  border: 2px dashed var(--gray50);\n  display: flex;\n  height: 17rem;\n  justify-content: center;\n  margin: 3rem 0 0;\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "ocXQoK-y7DgIx6zr6KlYzw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
